import { render, staticRenderFns } from "./a9.vue?vue&type=template&id=387325f0&scoped=true"
import script from "./a9.vue?vue&type=script&lang=js"
export * from "./a9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387325f0",
  null
  
)

export default component.exports